/* eslint-disable max-len */
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 */

/**
 * Inactive eTextbook access close icon (18x18 glyph in 24x24 container).
 *
 * @file RosterAccessInactiveIcon.jsx
 * @author Anuja Gaikwad
 * @since 2.3.5
 */

import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

function RosterAccessInactiveIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 18 18">
      <path
        d="M17.7078 16.0459L10.6397 9.05637L17.6327 1.99165C18.0838 1.54071 18.0838 0.789144 17.6327 0.338205C17.1815 -0.112735 16.5048 -0.112735 16.0536 0.338205L9.0607 7.40292L1.9926 0.413361C1.54145 -0.0375783 0.789522 -0.0375783 0.338366 0.413361C-0.112789 0.864301 -0.112789 1.54071 0.338366 1.99165L7.40647 9.05637L0.413559 16.1211C-0.0375963 16.572 -0.0375963 17.2484 0.413559 17.6994C0.639137 17.9248 0.939907 18 1.24068 18C1.54145 18 1.84222 17.9248 2.0678 17.6994L9.0607 10.6347L16.1288 17.6242C16.3544 17.8497 16.6551 17.9248 16.9559 17.9248C17.2567 17.9248 17.5575 17.8497 17.783 17.6242C18.0838 17.1733 18.0838 16.4969 17.7078 16.0459Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export default RosterAccessInactiveIcon;
